import { z } from 'zod';
import { paginatedQuerySchema } from '~/util/types/api';
import { baseLevelSchema } from '~/util/types/levels';
import { baseUserSchema } from '~/util/types/users';

export const recordsParamsSchema = z
    .object({
        level: baseLevelSchema.nullable().default(null),
        submitter: baseUserSchema.nullable().default(null),
        mobile: z.boolean().nullable().default(null),
        verification: z.boolean().nullable().default(null),
        sort: z
            .enum(['CreatedAt', 'UpdatedAt', 'AchievedAt', 'CompletionTime'])
            .default('UpdatedAt'),
        reverseSort: z.boolean().default(false),
    })
    .extend(paginatedQuerySchema().shape);

export type recordsParamsType = z.infer<typeof recordsParamsSchema>;

export const defaultRecordsParams = recordsParamsSchema.parse({});
